module.exports = __webpack_public_path__ + "img/2021AllotteeVisayas.7c488d96.jpg";